import { Injectable } from "@angular/core";

@Injectable()
export class AuthPublicService {
  userId: number = 0;
  orgId: number = 0;
}



// WEBPACK FOOTER //
// ./client/app/auth.service.ts